export const BUDGET2025_PAGE_SIZE = 10;
export const BUDGET2025_PAGE_QUERY = "/keywords/singapore-budget-2025";
export const BUDGET2025_LATEST_NEWS_TOTAL_SIZE = 15;
export const BUDGET2025_LATEST_NEWS_SIZE = 4;
export const BUDGET2025_LATEST_NEWS_SIZE_PRE = 5;
export const BUDGET2025_LATEST_NEWS_SIZE_POST = 3;
export const BUDGET2025_INFOGRAPHICS_LINK =
  "https://static1.businesstimes.com.sg/bt_files/specials/singapore-budget-2024/singapore-budget-revenue-and-spending-breakdown-2024/index.html";
